import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'adminArtifact'
const initialState = {
  list: null,
  loading: false,
   error: null,
}


export const search = createApiAction('adminArtifact/search', client.search('/api/evaluation/admin/self/artifact'))
export const get = createApiAction('adminArtifact/get', client.retrieve('/api/evaluation/admin/self/artifact/:id'))
export const save = createApiAction('adminArtifact/save', client.save('/api/evaluation/admin/self/artifact'))
export const destroy = createApiAction('adminArtifact/delete', client.destroy('/api/evaluation/admin/self/artifact/:id'))

const update = (state, action) => {
  const updatedItem = action.payload;

  if (state.list.some(item => item.id === updatedItem.id)) {
    state.list = state.list.map(item =>
      item.id === updatedItem.id ? { ...item, ...updatedItem } : item
    );
  } else {
    state.list = [...state.list, updatedItem];
  }
};

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearArtifact: state => {state.list = null},
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
        state.loading = false;
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload.id)
      }
      )
  },
})

export const { clearArtifact } = sessionSlice.actions
export default sessionSlice.reducer
